"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Plus } from "lucide-react";
const faqs = [{
  question: "What is the minimum acreage required for a TCA?",
  answer: "We typically perform Timber Cruise Analysis for woodlots starting at 100 acres. For smaller parcels, please contact our team."
}, {
  question: "What geographic regions does GTMX Labs cover?",
  answer: "We currently provide full coverage across the Pacific Northwest and the Southeast timber belts. We are rapidly expanding to include the Northeast and Lake States."
}, {
  question: "How accurate is the LiDAR inventory compared to a manual cruise?",
  answer: "While a manual cruise samples 5-10% of a stand, our LiDAR + AI technology inventories 100% of your trees. This results in a significantly higher confidence interval for volume and forest type distribution."
}, {
  question: "Can the TCA report be used for official timber sales?",
  answer: "Absolutely. The TCA provides defensible, data-backed valuation ranges and merchantable volume by product class, giving you a powerful negotiation tool when dealing with mills or timber buyers."
}, {
  question: "How do you ensure my land data remains confidential?",
  answer: "Data security is central to our defense-grade heritage. Your property boundaries, inventory data, and valuation reports are encrypted and never shared with third parties without your explicit consent."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="222607" id="frequently-asked-questions" className="bg-background text-foreground py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default mb-4 text-foreground tracking-tight">
            Logistics & Accuracy
          </h2>
          <p className="text-muted-foreground font-default max-w-2xl mx-auto text-lg">
            Common questions about our LiDAR technology, geographic coverage, and timber valuation process.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card/40 backdrop-blur-sm border border-border rounded-md overflow-hidden shadow-sm data-[state=open]:border-primary/50 transition-all duration-300">
              <AccordionTrigger className="hover:no-underline px-6 py-5 [&>svg:last-child]:hidden [&[data-state=open]_.plus-icon]:rotate-45 hover:bg-primary/5 transition-colors">
                <span className="text-left font-default text-lg font-semibold pr-4 text-foreground">
                  {faq.question}
                </span>
                <div className="shrink-0 ml-auto flex items-center justify-center size-8 rounded-sm bg-primary/10">
                  <Plus className="size-5 text-primary transition-transform duration-300 plus-icon" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-mono px-6 pb-6 pt-0 text-sm leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}